export const cms: any = {
  title: "タイトル",
  summary: "概要",
  tagList: "タグ",
  lineFooterText: "固定LINEボタンテキスト",
  relatedPostIds: "関連記事",
  scheduledApplyAt: "公開予定日時",
  searchTypes: "検索表示タイプ",
};
